export default __webpack_public_path__ + "static/media/AlarmTimeRange.8c2cd4fc.png";